import { ICreateItemProcessoRiscosUseCase } from "../../../presentation/useCases/create/create_item_processo_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateProcessoRiscosUseCase

export class CreateItemProcessoRiscosUseCase implements ICreateItemProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createItemProcessoRiscos(IdProcesso: number, Descricao: string, IdFuncionarioResp: number | null, IdFuncionarioCoresp: number | null, 
    DataAtualizacao: Date | null, Observacao: string | null ): Promise<number> {
    
    const response = await this.repository.createItemProcessoRiscos(IdProcesso, Descricao, IdFuncionarioResp, IdFuncionarioCoresp, DataAtualizacao, Observacao );

    return response.idItemProcesso;
  }
}